module.exports = __webpack_public_path__ + "img/christmas-light-medium.46572bcb.svg";